module.exports = __webpack_public_path__ + "static/wevote_two-2a97492822a287d271ad8cb4984ee562.jpg";